import { createDirectReportsBreadcrumbsContext } from "@/components/shared/DirectReportsBreadcrumbsContext";
import {
  ReportType,
  SettingsPeriod,
  WinRateDirectReportsResponse
} from "@/entities/reporting/types";

const { BreadcrumbsProvider, useBreadcrumbs } =
  createDirectReportsBreadcrumbsContext<WinRateDirectReportsResponse>({
    reportType: ReportType.WIN_RATE,
    responseKey: "winRate",
    defaultPeriod: SettingsPeriod.LAST_12_MONTHS,
    getUserIds: (data) =>
      data?.overall?.winRates ? Object.keys(data.overall.winRates) : []
  });

export const WinRateBreadcrumbsProvider = BreadcrumbsProvider;
export const useWinRateBreadcrumbs = useBreadcrumbs;
